import { pathOr } from "ramda";
import getWithToken from "./base/get-with-token";

/**
 * Returns all distinct customer suburbs for the current tenant, shaped like the
 * customer-taxonomy options ({ id, taxonomy_label }) so the "Suburb" filter can
 * reuse the same Select rendering as "Water zone".
 *
 * Backend: GET /customer-suburbs -> { data: ["Newcastle", "Maitland", ...] }
 */
const getCustomerSuburbsApi = getWithToken(`/customer-suburbs`);

const getCustomerSuburbs = async () => {
  const result = await getCustomerSuburbsApi();
  return pathOr([], ["data", "data"], result).map((name) => ({
    id: name,
    taxonomy_label: name,
  }));
};

export default getCustomerSuburbs;
